/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ApiDomainHoster;
(function (ApiDomainHoster) {
    ApiDomainHoster["DOMAIN_HOSTER_AWS"] = "DomainHosterAWS";
    ApiDomainHoster["DOMAIN_HOSTER_CLOUDFLARE"] = "DomainHosterCloudflare";
})(ApiDomainHoster || (ApiDomainHoster = {}));
export function ApiDomainHosterFromJSON(json) {
    return ApiDomainHosterFromJSONTyped(json, false);
}
export function ApiDomainHosterFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ApiDomainHosterToJSON(value) {
    return value;
}
